import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'
import echarts from 'echarts'
import '@/styles/index.scss' // global css
import 'ant-design-vue/dist/antd.css'
import '@/styles/ant-message.scss'
import Antd from 'ant-design-vue'
import VDistpicker from 'v-distpicker'
import { vueBaberrage } from 'vue-baberrage'
import '@/utils/sticky.js'
import VueCropper from 'vue-cropper'
// 引入自定义toast组件
import toastRegistry from '@/components/Toast/index'
Vue.use(toastRegistry)
import '@/icons' // icon
Vue.prototype.$echarts = echarts
import Vant from 'vant'
import 'vant/lib/index.css'
import visibility from 'vue-visibility-change'
import 'zhulong-common/dist/zl-common.css'
import 'zl-imalert-common/dist/zl-imalert-common.css'
import zlCommon from 'zhulong-common'
import zlImalert from 'zl-imalert-common'
import VueClipboard from 'vue-clipboard2'
import { Message } from 'element-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper /* { default global options } */)

// 全局注册组件
import aiAnalysis from '@/components/AiAnalysis/index.vue'
Vue.component('AiAnalysis', aiAnalysis)

// import 'zhulong-common/dist/zl-common.css'
// import zlCommon from 'zhulong-common'
// Vue.use(zlCommon)
// 注入全局属性$message

const $message = option => {
  console.log(option)
  return ElementUI.Message({
    ...option,
    offset: 80
  })
}

['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = option => {
    if (typeof option === 'string') {
      option = {
        message: option,
        offset: 80
      }
    }
    option.type = type
    return ElementUI.Message(option)
  }
})
Vue.prototype.$message = $message
Vue.prototype.$message.closeAll = Message.closeAll
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(visibility)
Vue.component('v-distpicker', VDistpicker)
Vue.use(vueBaberrage)
Vue.use(VueCropper)
Vue.use(zlImalert)
Vue.use(zlCommon)
Vue.use(Vant)
Vue.use(VueClipboard)
Vue.prototype.$message = Message
Vue.prototype.$keyBoard = function(vm) {
  document.onkeydown = function() {
    const key = window.event.keyCode// keyCode键盘码值
    const ctrlKey = window.event.ctrlKey
    // 当按下键盘1时，执行有参函数keydown(1, 0),这里的函数keydown按自己的需求更改
    if (ctrlKey && key == 13) { // ctrl ->键盘按键 ctrl  enter ->键盘按键 enter
      vm.keydown(true) // keydown是自定义方法。按键触发
    }
  }
}

/**
 * 全局路由钩子
 * to: 将要进入的，路由对象
 * from:正要离开，路由对象
 */
router.beforeEach((to, from, next) => {
  // console.log(from)
  if (from.query.f) {
    document.getElementById('public_title').innerHTML = '廉洁风险防控平台'
  }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

